module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ambis-meter"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Ambis Test',
          to: {
            path: '/ambis-test'
          },
          exact: true,
        },
        {
          text: 'Skala'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Skala")]), _vm._v(" "), _c('v-card', {
    staticClass: "mt-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-8"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "font-weight-500",
    attrs: {
      "md": "2"
    }
  }, [_vm._v("\n                    Nama Tema Skala\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "font-weight-bold",
    attrs: {
      "md": "10"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.theme.theme_name || "-") + "\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "font-weight-500 py-2",
    attrs: {
      "md": "2"
    }
  }, [_vm._v("\n                    Jenis User\n                ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 font-weight-bold",
    attrs: {
      "md": "10"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.theme.target_user || "-") + "\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-5"
  }, [_c('v-card-title', [_vm._v("\n            Daftar Skala\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.createScale()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                Tambah Skala\n            ")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    key: _vm.tableKey,
    attrs: {
      "items": _vm.row,
      "headers": _vm.headers,
      "has-action": true,
      "has-leaderboard": true,
      "customWidth": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-total-items": _vm.total_data,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "row-expanded-detail": _vm.row
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editScale()
      },
      "deleted": function($event) {
        return _vm.confirmDeleteItem($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: $event.key
        };
        _vm.doSearch();
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "480px"
    },
    model: {
      value: (_vm.confirmDialog),
      callback: function($$v) {
        _vm.confirmDialog = $$v
      },
      expression: "confirmDialog"
    }
  }, [_c('v-card', {
    staticClass: "py-2"
  }, [_c('v-card-title', {
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                Apakah anda akan menghapus Skala ini ?\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                Skala\n                "), _c('b', [_vm._v(_vm._s(_vm.selectedRow ? _vm.selectedRow.scale_name : ""))]), _vm._v(" akan\n                dihapus.\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmDialog = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "depressed": "",
      "loading": _vm.isLoadingForm
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem()
      }
    }
  }, [_vm._v("\n                    Ok\n                ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d5b2030","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/DetailSkala.vue
// module id = 1422
// module chunks = 1